const utils = {
    viewProjectEnabled: process.env.REACT_APP_VIEW_PROJECT_ENABLED === 'true',
    viewLoginEnabled: process.env.REACT_APP_VIEW_LOGIN_ENABLED === 'true',
    viewProjectLoginEnabled: process.env.REACT_APP_VIEW_PROJECT_ENABLED === 'true' && process.env.REACT_APP_VIEW_LOGIN_ENABLED === 'true'
};
  
export default utils;